import { IoIosArrowDropup, IoMdInformationCircleOutline } from "react-icons/io"
import { data } from "react-router-dom"

// htmls
const roomMarkersData = [
	{
		id: "living-room-marker",
		img: "assets/living-room-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Living Room",
		type: "room"
	},
	{
		id: "kitchen-marker",
		img: "assets/kitchen-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Kitchen",
		type: "room"

	},
	{
		id: "floor-2-marker",
		img: "assets/floor-2-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Floor 2",
		type: "room"
	},
	{
		id: "master-bedroom-marker",
		img: "assets/room-2-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Master Bedroom",
		type: "room"
	},
	{
		id: "bathroom-2-marker",
		img: "assets/F2B-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bathroom 2",
		type: "room"
	},
	{
		id: "bathroom-1-marker",
		img: "assets/F1B-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bathroom 1",
		type: "room"
	},
	{
		id: "bedroom-1-marker",
		img: "assets/room-1-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bedroom 1",
		type: "room"
	},
	{
		id: "bedroom-2-marker",
		img: "assets/room-1-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bedroom 2",
		type: "room"
	},
	{
		id: "workroom-marker",
		img: "assets/workroom-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Workroom",
		type: "room"
	},
	{
		id: "laundry-room-marker",
		img: "assets/F2L-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Laundry Room",
		type: "room"
	},
]

// htmls
const infoMarkersData = [
	{
		id: "painting-info",
		icon: IoMdInformationCircleOutline,
		name: "Painting",
		type: "info"
	},
	{
		id: "book-info",
		icon: IoMdInformationCircleOutline,
		name: "Book",
		type: "info"
	}
]

const customMarkersData = [
	{
		id: "living-room-marker",
		img: "assets/living-room-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Living Room",
		type: "room"
	},
	{
		id: "kitchen-marker",
		img: "assets/kitchen-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Kitchen",
		type: "room"

	},
	{
		id: "floor-2-marker",
		img: "assets/floor-2-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Floor 2",
		type: "room"
	},
	{
		id: "master-bedroom-marker",
		img: "assets/room-2-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Master Bedroom",
		type: "room"
	},
	{
		id: "bathroom-2-marker",
		img: "assets/F2B-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bathroom 2",
		type: "room"
	},
	{
		id: "bathroom-1-marker",
		img: "assets/F1B-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bathroom 1",
		type: "room"
	},
	{
		id: "bedroom-1-marker",
		img: "assets/room-1-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bedroom 1",
		type: "room"
	},
	{
		id: "bedroom-2-marker",
		img: "assets/room-1-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Bedroom 2",
		type: "room"
	},
	{
		id: "workroom-marker",
		img: "assets/workroom-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Workroom",
		type: "room"
	},
	{
		id: "laundry-room-marker",
		img: "assets/F2L-1024x1024.png",
		icon: IoIosArrowDropup,
		name: "Laundry Room",
		type: "room"
	},
	{
		id: "painting-info",
		icon: IoMdInformationCircleOutline,
		name: "Painting",
		type: "info"
	},
	{
		id: "book-info",
		icon: IoMdInformationCircleOutline,
		name: "Book",
		type: "info"
	}
]

const panelContentsData = [
	{
		id: "book-info-content",
		marker: "book-marker",
		file: "/assets/Virtual Exhibition.pdf#zoom=41",
		url: null,
		img: null,
		longText: null,
	},
	{
		id: "painting-info-content",
		marker: "painting-marker",
		url: "https://en.wikipedia.org/wiki/Sunflowers_(Van_Gogh_series)",
	}
]

const roomMarkerMapData = [
	{
		id: "living-room-marker",
		panorama: "assets/compressed/living-room-360.jpeg",
		markers: [
			{
				id: "painting-marker",
				html: "painting-info",
				position: { yaw: "325deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
			{
				id: "bedroom-1-marker",
				html: "bedroom-1-marker",
				position: { yaw: "277deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "bathroom-1-marker",
				html: "bathroom-1-marker",
				position: { yaw: "304deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "kitchen-marker",
				html: "kitchen-marker",
				position: { yaw: "260deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "50deg", pitch: "0deg" },
				anchor: 'top center',
				data: { type: "room" }
			},
		]
	},
	{
		id: "kitchen-marker",
		panorama: "assets/compressed/kitchen-360.jpeg",
		markers: [
			{
				id: "living-room-marker",
				html: "living-room-marker",
				position: { yaw: "110deg", pitch: "-10deg" },
				data: { type: "room" }
			}
		]
	},
	{
		id: "bathroom-1-marker",
		panorama: "assets/compressed/KamarMandiLT1-360.jpeg",
		markers: [
			{
				id: "living-room-marker",
				html: "living-room-marker",
				position: { yaw: "135deg", pitch: "-10deg" },
				data: { type: "room" }

			}
		]
	},
	{
		id: "bedroom-1-marker",
		panorama: "assets/compressed/KamarTidurLT1-360.jpeg",
		markers: [
			{
				id: "living-room-marker",
				html: "living-room-marker",
				position: { yaw: "130deg", pitch: "-15deg" },
				data: { type: "room" }

			}
		]
	},
	{
		id: "floor-2-marker",
		panorama: "assets/compressed/F2LR.jpeg",
		markers: [
			{
				id: "workroom-marker",
				html: "workroom-marker",
				position: { yaw: "90deg", pitch: "-10deg" },
				data: { type: "room" }

			},
			{
				id: "living-room-marker",
				html: "living-room-marker",
				position: { yaw: "0deg", pitch: "-10deg" },
				data: { type: "room" }

			},
			{
				id: "master-bedroom-marker",
				html: "master-bedroom-marker",
				position: { yaw: "140deg", pitch: "-10deg" },
				data: { type: "room" }

			},
			{
				id: "bedroom-2-marker",
				html: "bedroom-2-marker",
				position: { yaw: "200deg", pitch: "-10deg" },
				data: { type: "room" }

			},
			{
				id: "bathroom-2-marker",
				html: "bathroom-2-marker",
				position: { yaw: "185deg", pitch: "-10deg" },
				data: { type: "room" }

			},
			{
				id: "laundry-room-marker",
				html: "laundry-room-marker",
				position: { yaw: "220deg", pitch: "-10deg" },
				data: { type: "room" }

			},
		]
	},
	{
		id: "master-bedroom-marker",
		panorama: "assets/compressed/KamarUtamaLT2-360.jpeg",
		markers: [
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "291deg", pitch: "-10deg" },
				data: { type: "room" }
			}
		]
	},
	{
		id: "bedroom-2-marker",
		panorama: "assets/compressed/KamarTidurLT2-360.jpeg",
		markers: [
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "140deg", pitch: "-8deg" },
				data: { type: "room" }

			}
		]
	},
	{
		id: "bathroom-2-marker",
		panorama: "assets/compressed/KamarMandiLT2-360.jpeg",
		markers: [
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "350deg", pitch: "-10deg" },
				data: { type: "room" }

			}
		]
	},
	{
		id: "workroom-marker",
		panorama: "assets/compressed/F2WR.jpeg",
		markers: [
			{
				id: "book-marker",
				html: "book-info",
				position: { yaw: "330deg", pitch: "-18deg" },
				anchor: 'top center',
				data: { type: "info" }
			},
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "260deg", pitch: "-15deg" },
				data: { type: "room" }
			}
		]
	},
	{
		id: "laundry-room-marker",
		panorama: "assets/compressed/LaundryRoom-360.jpeg",
		markers: [
			{
				id: "floor-2-marker",
				html: "floor-2-marker",
				position: { yaw: "52deg", pitch: "-15deg" },
				data: { type: "room" }
			}
		]
	}

]

const galleryData = [
	{
		id: 'living-room',
		panorama: 'assets/compressed/living-room-360.jpeg',
		// panorama: get panorama based on roomMarkerMapData,
		thumbnail: 'assets/living-room-1024x1024.png',
		name: 'Living Room',
		options: {
				caption: 'Living Room',
		},
	},	
	{
		id: 'kitchen',
		panorama: 'assets/compressed/kitchen-360.jpeg',
		thumbnail: 'assets/kitchen-1024x1024.png',
		name: 'Kitchen',
		options: {
				caption: 'Kitchen',
		},
	},	
	{
		id: 'floor-2',
		panorama: 'assets/compressed/F2LR.jpeg',
		thumbnail: 'assets/floor-2-1024x1024.png',
		name: 'Floor 2',
		options: {
				caption: 'Floor 2',
		},
	},	
	{
		id: 'master-bedroom',
		panorama: 'assets/compressed/KamarUtamaLT2-360.jpeg',
		thumbnail: 'assets/room-2-1024x1024.png',
		name: 'Master Bedroom',
		options: {
				caption: 'Master Bedroom',
		},
	},	
	{
		id: 'bathroom-2',
		panorama: 'assets/compressed/KamarMandiLT2-360.jpeg',
		thumbnail: 'assets/F2B-1024x1024.png',
		name: 'Bathroom 2',
		options: {
				caption: 'Bathroom 2',
		},
	},	
	{
		id: 'bathroom-1',
		panorama: 'assets/compressed/KamarMandiLT1-360.jpeg',
		thumbnail: 'assets/F1B-1024x1024.png',
		name: 'Bathroom 1',
		options: {
				caption: 'Bathroom 1',
		},
	},	
	{
		id: 'bedroom-1',
		panorama: 'assets/compressed/KamarTidurLT1-360.jpeg',
		thumbnail: 'assets/room-1-1024x1024.png',
		name: 'Bedroom 1',
		options: {
				caption: 'Bedroom 1',
		},
	},	
	{
		id: 'bedroom-2',
		panorama: 'assets/compressed/KamarTidurLT2-360.jpeg',
		thumbnail: 'assets/room-1-1024x1024.png',
		name: 'Bedroom 2',
		options: {
				caption: 'Bedroom 2',
		},
	},	
	{
		id: 'workroom',
		panorama: 'assets/compressed/F2WR-360.jpeg',
		thumbnail: 'assets/workroom-1024x1024.png',
		name: 'Workroom',
		options: {
				caption: 'Workroom',
		},
	},	
	{
		id: 'laundry-room',
		panorama: 'assets/compressed/LaundryRoom-360.jpeg',
		thumbnail: 'assets/F2L-1024x1024.png',
		name: 'Laundry Room',
		options: {
				caption: 'Laundry Room',
		},
	},	
]

const mapData = [
	{
		imageUrl: 'assets/Denah.png',
		center: { x: 535, y: 300 },
		rotation: '0',
		static: 'true',
		coneColor: '#3498db',
		buttons: {
			reset: false,    // hides the reset zoom button
		},
		coneSize: '80',
		defaultZoom: '50',
		minZoom: '50',
		maxZoom: '50',
		hotspots: [
			{
				id: 'kitchen',
				x: 150,
				y: 550,
				color: '#3498db',
				tooltip: 'Kitchen',
			},
			{
				id: 'floor-2',
				x: 790,
				y: 60,
				color: '#3498db',
				tooltip: 'Floor 2',
			},
			{
				id: 'bathroom-1',
				x: 370,
				y: 60,
				color: '#3498db',
				tooltip: 'Bathroom 1',
			},
			{
				id: 'bedroom-1',
				x: 150,
				y: 175,
				color: '#3498db',
				tooltip: 'Bedroom 1',
			},
			{
				id: 'workroom',
				x: 2550,
				y: 175,
				color: '#3498db',
				tooltip: 'Workroom',
			},
			{
				id: 'living-room',
				x: 2240,
				y: 60,
				color: '#3498db',
				tooltip: 'Living Room',
			},
			{
				id: 'bathroom-2',
				x: 2250,
				y: 550,
				color: '#3498db',
				tooltip: 'Bathroom 2',
			},
			{
				id: 'bedroom-2',
				x: 2075,
				y: 175,
				color: '#3498db',
				tooltip: 'Bedroom 2',
			},
			{
				id: 'master-bedroom',
				x: 2550,
				y: 400,
				color: '#3498db',
				tooltip: 'Master Bedroom',
			},
			{
				id: 'laundry-room',
				x: 2050,
				y: 550,
				color: '#3498db',
				tooltip: 'Laundry Room',
			},
		],
	}
]


export default {
	infoMarkersData,
	roomMarkersData,
	panelContentsData,
	roomMarkerMapData,
	galleryData,
	mapData
}

/***
 * would probably merge info marker with room marker as custom marker
 * their difference were just animation and the info marker don't have image
 * 
 * we use html to make custom marker but it has to be a string. so we use React
 * renderToStaticMarkup function to render React component to HTML string. 
 * But creating the marker dynamically probably needs a.. helper?
 * mainly to do the renderToString function for every marker and then pair the marker
 * to associated room. This pairing is practically a database structure haha  
 * 
 * anyway..
 * 
 * don't forget a break in switch case function
 * don't forget arrow function with {} must explicitly use return keyword as {} means a function body
 * 
 */